import styled from '@emotion/styled'
import { Container, Typography } from '@mui/material'
import { DelekRecallsResponse, getRecalls } from "api/delek"
import { CommonForm, CommonInput, CommonSubmit } from "common/forms"
import RecallMarkdown from "docs/recall.mdx"
import { memo, useState } from "react"
import RecallSchema, { initialFormState } from "./RecallSchema"
import Recalls from "./Recalls"

const Styled = {
  Title: styled(Typography)`
    font-size: 16px;
    font-weight: bold;
    margin: 30px 0 20px;
    color: ${(p) => p.theme.colors.oceanBlue};
    ${(p) => p.theme.breakpoints.up("md")} {
      font-size: 22px;
      margin: 30px 0;
    }
  `,
  InputWrapper: styled.div`
    max-width: 340px;
  `
}

const RecallForm = () => {
  const [response, setResponse] = useState<DelekRecallsResponse>(null)
  return (
    <>
      <CommonForm
        initialValues={initialFormState}
        validationSchema={RecallSchema}
        onSubmit={async (values) => {
          const { data } = await getRecalls(values.licenceOrChassis)
          setResponse(data)
        }}
        render={() => (
          <Container>
            <Styled.Title>לבדיקה האם יש קריאה חוזרת לרכב שלך</Styled.Title>
            <Styled.InputWrapper>
            <CommonInput
              label="מספר רישוי או השלדה של הרכב"
              name="licenceOrChassis"
            />
            </Styled.InputWrapper>
            <CommonSubmit label="בדוק את הרכב שלך" />
          </Container>
        )}
      />
      {response?.result && (
        <>
          <Recalls data={response.data} />
          <RecallMarkdown />
        </>
      )}
    </>
  )
}

export default memo(RecallForm)
